export type RuntimeRoutingInput = {
  forceGraph: boolean;
  useLangGraph: boolean;
  trafficPct: number;
  emergencyLegacyFallback: boolean;
  randomPercent?: number;
};

export type RuntimeRoutingDecision = {
  disableLegacyChat: boolean;
  routeToGraph: boolean;
  method: 'langgraph';
};

export function resolveRuntimeRouting(_input: RuntimeRoutingInput): RuntimeRoutingDecision {
  return {
    disableLegacyChat: true,
    routeToGraph: true,
    method: 'langgraph',
  };
}
